import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function QuizLayout({ title, action, children }) {
  const navigate = useNavigate();
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: 3 }}>
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, gap: 2 }}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/')} data-testid="quiz-back">
            Back to Spectra
          </Button>
          {title && <Typography variant="h5" sx={{ fontWeight: 700 }}>{title}</Typography>}
          <Box sx={{ flexGrow: 1 }} />
          {action}
        </Box>
        {children}
      </Container>
    </Box>
  );
}
